import React, { useEffect, useState } from "react";

import "./ProductGroupCard.css";

const ProductGroupCard = ({
  name,
  data,
  setShowProdGroups,
  setSelectedProdGroup,
  setProdGroupEdits,
}) => {
  const [gdata, setGdata] = useState(data?.groupBy("prodCatName"));

  useEffect(() => {
    setGdata(data.groupBy("prodCatName"));
  }, [data]);

  Array.prototype.groupBy = function (key) {
    return this.reduce(function (groups, item) {
      const val = item[key];
      groups[val] = groups[val] || [];
      groups[val].push(item);
      return groups;
    }, {});
  };

  const showSingleProdGroup = () => {
    setShowProdGroups(false);
    setSelectedProdGroup(name);
    setProdGroupEdits({
      ["prodGroupID"]: data[0]["prodGroupID"],
      ["productGroup"]: name,
    });
  };

  return (
    <div
      // className={grow ? "productGroupCard prodGroupGrow" : "productGroupCard"}
      className='productGroupCard'
      onClick={showSingleProdGroup}
    >
      <h2>{name}</h2>
      <div className='pgcard-products'>
        {gdata ? Object.keys(gdata).map((key) => <p key={key}>{key}</p>) : ""}
      </div>
    </div>
  );
};

export default ProductGroupCard;
